<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class="chart-wrap">
        <DxToolbar>
          <DxItem
            #default
            location="before"
            locate-in-menu="never"
          >
            <div class="toolbar-label"><b>년도 : </b></div>
          </DxItem>
          <DxItem
            :options="selectBoxYearOptions"
            location="before"
            locate-in-menu="auto"
            widget="dxSelectBox"
          />
        </DxToolbar>
        <DxChart
          id="chart"
          :data-source="chartGridData"
          palette="Office"
          title="연 구매현황"
         >
          <DxCommonSeriesSettings
            type="stackedbar"
            argument-field="발생월"
          />
          <DxSeries
            v-for="materials in 자재유형"
            :key="materials.코드명"
            :value-field="materials.코드명"
            :name="materials.코드명"
          />
          <DxCommonAxisSettings>
            <DxGrid :visible="true"/>
          </DxCommonAxisSettings>
          <DxValueAxis
            name="amount"
            position="left"
          />
          <DxValueAxis
            :tick-interval="10"
            :show-zero="true"
            :value-margins-enabled="false"
            name="rate"
            position="right"
          >
          </DxValueAxis>
          <DxMargin :bottom="20"/>
          <DxArgumentAxis
            :allow-decimals="false"
            :axis-division-factor="30"
          >
            <DxLabel>
              <DxFormat type="decimal"/>
            </DxLabel>
          </DxArgumentAxis>
          <DxLegend
            vertical-alignment="top"
            horizontal-alignment="right"
          />
          <DxExport
            :enabled="true"
            title="연생산현황"
            />
          <DxTooltip
            :enabled="true"
            :shared="true"
            :customize-tooltip="customizeTooltip"
          />
          <DxSize :height="screenHeight * 0.4"/>
        </DxChart>
      </div>
      <div class="pivot-wrap">
        <DxToolbar class=‘select-group’ style=‘margin-left:0;’>
          <DxItem
            #default
            location=“after”
            locate-in-menu=“never”
          >
            <div class=“toolbar-label” style=‘color:red;’>(금액:천원)</div>
          </DxItem>
        </DxToolbar>
        <DxPivotGrid
          ref="refPivot"
          :allow-sorting-by-summary="true"
          :allow-sorting="true"
          :allow-filtering="true"
          :allow-expand-all="true"
          :show-borders="true"
          :show-column-grand-totals="false"
          :show-row-grand-totals="true"
          :show-row-totals="true"
          :show-column-totals="true"
          :data-source="dataSource"
          @cell-prepared = 'onCellPrepared'
          @exporting="onExporting"
         >
         <DxFieldChooser
            :enabled="false"
            :height="350"
          />
          <DxPivotExport
            :enabled="true"
            :file-name="excelTitle"
          />
         </DxPivotGrid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
import {
  DxChart,
  DxSeries,
  DxValueAxis,
  DxArgumentAxis,
  DxCommonSeriesSettings,
  DxCommonAxisSettings,
  DxGrid,
  DxExport,
  DxLegend,
  DxMargin,
  DxTooltip,
  DxLabel,
  DxFormat,
  DxSize
} from 'devextreme-vue/chart'
import { DxPivotGrid, DxExport as DxPivotExport, DxFieldChooser } from 'devextreme-vue/pivot-grid'
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source'
import AppLib from '../../share/AppLib'
// excel export 관련 lib
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportPivotGrid } from 'devextreme/excel_exporter'
export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '연 구매현황'
        }
      ],
      excelTitle: null,
      screenHeight: null,
      // 연 월 관련 변수
      selectBoxYearOptions: null,
      selectBoxMonthOptions: null,
      selectedMonth: null,
      thisYear: null,
      // pivot grid
      pivotGirdData: null,
      dataSource: null,
      // chart
      chartGridData: null,
      자재유형: []
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxToolbar,
    DxItem,
    // pivot
    DxPivotGrid,
    DxPivotExport,
    DxFieldChooser,
    // chart
    DxChart,
    DxSeries,
    DxValueAxis,
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxCommonAxisSettings,
    DxGrid,
    DxExport,
    DxLegend,
    DxMargin,
    DxTooltip,
    DxLabel,
    DxFormat,
    DxSize
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    let array = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    for (let i = 0; i < array.length; i++) {
      let 자재유형 = array[i].코드
      if (자재유형 !== ConstDef.외주직납품) {
        this.자재유형.push(array[i])
      }
    }

    this.init()
    this.handleResize()
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    handleResize (e) {
      this.screenHeight = (screen.height)
    },
    customizeTooltip (pointInfo) {
      let text = ''
      for (let i in pointInfo.points) {
        text += `${pointInfo.points[i].seriesName}: ${AppLib.comma(Math.round(pointInfo.points[i].valueText))}(천) ( ${pointInfo.points[i].percentText} )\n`
      }
      text += `총합계 : ${AppLib.comma(Math.round(pointInfo.totalText))}(천)`
      return {
        text: text
      }
    },
    init () {
      this.thisYear = AppLib.getThisYear()
      this.selectedMonth = AppLib.getThisMonth()
      let tempArray = []
      for (let i = this.thisYear; i >= 2020; i--) {
        tempArray.push({ 'year': i })
      }
      this.selectBoxYearOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'year',
        displayExpr: 'year',
        value: this.thisYear,
        onValueChanged: (args) => {
          this.thisYear = args.value
          this.refreshPivotGrid(this.thisYear)
        }
      }
      tempArray = []
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          tempArray.push({ 'name': i + '월', value: '0' + i })
        } else {
          tempArray.push({ 'name': i + '월', value: '' + i })
        }
      }
      // makeMonth 할때 사용
      this.selectBoxMonthOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'value',
        displayExpr: 'name',
        value: this.selectedMonth,
        onValueChanged: (args) => {
          this.selectedMonth = args.value
          this.refreshPivotGrid(this.thisYear)
        }
      }
      this.refreshPivotGrid(this.thisYear)
    },
    // Pivot
    onCellPrepared (e) {
      if (e.area === 'data') {
        if (e.cell.value === 0) {
          this.$Q(e.cellElement).find('span').text('')
        }
      }
    },
    /* ==============START EXCEL EXPORT============ */
    onExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet(this.excelTitle)
      exportPivotGrid({
        component: e.component,
        worksheet,
        customizeCell: ({ pivotCell, excelCell }) => {
          if (excelCell._value.model.value === 0) {
            excelCell._value.model.value = ''
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.excelTitle}.xlsx`)
        })
      })
      e.cancel = true
    },
    /* ==============END EXCEL EXPORT============ */
    makeMonthly (pivotGirdData) {
      let timeStamp
      for (let i = 0; i < this.selectBoxMonthOptions.items.length; i++) {
        timeStamp = `${this.thisYear}-${this.selectBoxMonthOptions.items[i].value}-01`
        let where = this.$_.findWhere(pivotGirdData, { 발생월: timeStamp })
        if (where === undefined) {
          const temp = {
            발생월: timeStamp,
            코드명: pivotGirdData[0].코드명
          }
          this.pivotGirdData.push(temp)
        }
      }
    },
    makeChartData () {
      this.chartGridData = []
      let timeStamp
      // console.log(test)
      for (let i = 0; i < this.selectBoxMonthOptions.items.length; i++) {
        timeStamp = `${this.thisYear}-${this.selectBoxMonthOptions.items[i].value}-01`
        this.chartGridData.push({ 발생월: timeStamp })
        for (let j in this.자재유형) {
          let where = this.$_.findWhere(this.pivotGirdData, { 발생월: timeStamp, 자재유형: this.자재유형[j].코드 })
          if (where !== undefined && where.금액 !== undefined) {
            let 코드명 = this.자재유형[j].코드명
            this.chartGridData[i][코드명] = where.금액
          }
        }
      }
    },
    refreshPivotGrid (year) {
      const param = { fromDate: `${year}-01-01`, toDate: `${year}-12-31 23:59:59` }
      this.excelTitle = `${year}년 구매현황`
      this.$_sp.runNoEncodeFindProc('spFindAll월구입비용ByDate', param)
        .then((data) => {
          this.pivotGirdData = this.$_sp.MakeModel(data)
          console.log(this.pivotGirdData.length)
          if (this.pivotGirdData.length > 0) {
            this.makeMonthly(this.pivotGirdData)
            this.setInitDataSource()
            this.makeChartData()
          } else {
            this.pivotGirdData = []
            this.chartGridData = []
            this.dataSource = []
          }
        })
    },
    setInitDataSource () {
      this.dataSource = new PivotGridDataSource({
        fields: [
          {
            caption: '자재유형',
            dataField: '코드명',
            area: 'row',
            width: '120',
            expanded: true
          },
          {
            dataField: '발생월',
            dataType: 'date',
            area: 'column',
            groupInterval: 'year',
            expanded: true
          },
          {
            dataField: '발생월',
            dataType: 'date',
            area: 'column',
            groupInterval: 'month',
            expanded: true
          },
          {
            caption: '금액',
            dataField: '금액',
            dataType: 'number',
            summaryType: 'sum',
            format: '#,##0',
            area: 'data'
          }
        ],
        store: this.pivotGirdData
      })
    }
  }
}
</script>

<style lang="scss">

</style>
